module.exports = __webpack_public_path__ + "static/media/searchList.fc0d3eda.svg";